import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import React from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";


export default function Mapss({ lat=36.794992, lon=10.0608771, canEdit,setPosition }) {




  const customIcon = new L.Icon({
    iconUrl: require("../assets/FrontOffice/images/icon.png"),
    iconSize: [25, 35],
    iconAnchor: [5, 30]
  });

  function MapEvents() {
    const map = useMapEvents({
      click(event) {
        if (canEdit) {
          const { latlng } = event;
          setPosition([latlng.lat, latlng.lng]);
        }
      }
    });
    return null;
  }

  return (
    <MapContainer
      className="map"
      center={[lat,lon]}
      zoom={6}
      scrollWheelZoom={true}
      style={{ width: "100%", height: "50vh"}}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> 
        contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Marker icon={customIcon} position={[lat,lon]} />
      <MapEvents />
    </MapContainer>
  );
}
